module.exports = __webpack_public_path__ + "OpenSans-Bold-892667349c5cff6fcf7e40439596b97c.woff";